/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createQuestion = /* GraphQL */ `
  mutation CreateQuestion(
    $classId: Int!
    $moduleId: String!
    $title: String!
    $text: String!
  ) {
    createQuestion(
      classId: $classId
      moduleId: $moduleId
      title: $title
      text: $text
    ) {
      id
      __typename
    }
  }
`;
export const createAnswer = /* GraphQL */ `
  mutation CreateAnswer(
    $classId: Int!
    $questionId: String!
    $answer: String!
  ) {
    createAnswer(classId: $classId, questionId: $questionId, answer: $answer) {
      id
      __typename
    }
  }
`;
export const saveProgressTracking = /* GraphQL */ `
  mutation SaveProgressTracking($input: ProgressTrackingInput!) {
    saveProgressTracking(input: $input) {
      id
      classId
      createDate
      lastActivityDate
      termId
      currentSessionId
      totalProgress
      currentLessonCompleted
      sessionTracking {
        sessionId
        assessmentPassed
        assignmentSubmitted
        activityDate
        totalViews
        progress
        playerHead
        __typename
      }
      newUnreadNotification {
        id
        type
        url
        qnaTitle
        classTitle
        classId
        text
        subText
        createDate
        qnaStartDate
        classCategory
        classUrlKey
        __typename
      }
      __typename
    }
  }
`;
export const createAssignment = /* GraphQL */ `
  mutation CreateAssignment($input: CreateAssignmentInput!) {
    createAssignment(input: $input) {
      id
      __typename
    }
  }
`;
export const updateAssignment = /* GraphQL */ `
  mutation UpdateAssignment($input: UpdateAssignmentInput!) {
    updateAssignment(input: $input) {
      id
      __typename
    }
  }
`;
export const createClassSubscription = /* GraphQL */ `
  mutation CreateClassSubscription($input: CreateClassSubscriptionInput!) {
    createClassSubscription(input: $input) {
      id
      previewToken
      __typename
    }
  }
`;
export const updateClassSubscription = /* GraphQL */ `
  mutation UpdateClassSubscription($input: UpdateClassSubscriptionInput!) {
    updateClassSubscription(input: $input) {
      id
      previewToken
      classId
      type
      previewActivationDate
      __typename
    }
  }
`;
export const saveAssessmentUserAnswer = /* GraphQL */ `
  mutation SaveAssessmentUserAnswer($input: AssessmentUserAnswerInput!) {
    saveAssessmentUserAnswer(input: $input) {
      id
      questionId
      userAnswerId
      correctAnswerId
      finished
      passed
      score
      currentSessionId
      totalProgress
      newUnreadNotification {
        id
        type
        url
        qnaTitle
        classTitle
        classId
        text
        subText
        createDate
        qnaStartDate
        classCategory
        classUrlKey
        __typename
      }
      __typename
    }
  }
`;
export const saveFavoriteLesson = /* GraphQL */ `
  mutation SaveFavoriteLesson($classId: Int!, $lessonId: String!) {
    saveFavoriteLesson(classId: $classId, lessonId: $lessonId) {
      classId
      lessonId
      active
      __typename
    }
  }
`;
export const deleteFavoriteLesson = /* GraphQL */ `
  mutation DeleteFavoriteLesson($classId: Int!, $lessonId: String!) {
    deleteFavoriteLesson(classId: $classId, lessonId: $lessonId) {
      classId
      lessonId
      active
      __typename
    }
  }
`;
export const updateUserNotification = /* GraphQL */ `
  mutation UpdateUserNotification($id: String!, $read: Boolean) {
    updateUserNotification(id: $id, read: $read) {
      success
      __typename
    }
  }
`;
export const modifyGiftSubscription = /* GraphQL */ `
  mutation ModifyGiftSubscription($input: GiftSubscriptionInput!) {
    modifyGiftSubscription(input: $input) {
      id
      classId
      libraryId
      createDate
      recipientName
      senderName
      claimed
      claimDate
      notificationTime
      emailAddress
      senderEmail
      classTitle
      classImage
      subscriberId
      classSubscriptionId
      invitationKey
      message
      __typename
    }
  }
`;
export const createVideoAssignmentSubmission = /* GraphQL */ `
  mutation CreateVideoAssignmentSubmission(
    $input: CreateVideoAssignmentSubmissionInput!
  ) {
    createVideoAssignmentSubmission(input: $input) {
      id
      __typename
    }
  }
`;
export const updateVideoAssignmentSubmission = /* GraphQL */ `
  mutation UpdateVideoAssignmentSubmission(
    $input: UpdateVideoAssignmentSubmissionInput!
  ) {
    updateVideoAssignmentSubmission(input: $input) {
      id
      __typename
    }
  }
`;
export const unsubmitVideoAssignmentSubmission = /* GraphQL */ `
  mutation UnsubmitVideoAssignmentSubmission(
    $input: UnsubmitVideoAssignmentSubmissionInput!
  ) {
    unsubmitVideoAssignmentSubmission(input: $input) {
      id
      __typename
    }
  }
`;
export const addVideoFromCloudinaryToSubmission = /* GraphQL */ `
  mutation AddVideoFromCloudinaryToSubmission(
    $input: AddVideoFromCloudinaryInput!
  ) {
    addVideoFromCloudinaryToSubmission(input: $input) {
      video {
        id
        createDate
        duration
        failed
        clips {
          path
          thumbnail
          ordinal
          __typename
        }
        thumbnails
        analysis {
          recordingIssues
          recordingQuality
          sideBySideCoverage
          summary
          topics {
            startTime
            endTime
            title
            summary
            __typename
          }
          __typename
        }
        status
        __typename
      }
      submissionId
      userId
      __typename
    }
  }
`;
export const updateRoomId = /* GraphQL */ `
  mutation UpdateRoomId($input: UpdateVideoAssignmentSubmissionRoomIdInput!) {
    updateRoomId(input: $input) {
      id
      __typename
    }
  }
`;
export const invokeCopyStepFunctions = /* GraphQL */ `
  mutation InvokeCopyStepFunctions($input: VideoCopyInput!) {
    invokeCopyStepFunctions(input: $input) {
      success
      __typename
    }
  }
`;
export const createSendbirdUser = /* GraphQL */ `
  mutation CreateSendbirdUser($input: SendbirdUserInput!) {
    createSendbirdUser(input: $input) {
      user_id
      nickname
      profile_url
      is_active
      __typename
    }
  }
`;
export const uploadToZapier = /* GraphQL */ `
  mutation UploadToZapier(
    $user_id: String!
    $user_email: String
    $message: String
    $date: String!
    $issue_type: String!
    $room: String
    $video: String
    $screenshot_link: String
  ) {
    uploadToZapier(
      user_id: $user_id
      user_email: $user_email
      message: $message
      date: $date
      issue_type: $issue_type
      room: $room
      video: $video
      screenshot_link: $screenshot_link
    ) {
      attempt
      id
      request_id
      status
      __typename
    }
  }
`;
export const addChatRecord = /* GraphQL */ `
  mutation AddChatRecord($input: ChatSessionInput!) {
    addChatRecord(input: $input) {
      attempt
      id
      request_id
      status
      __typename
    }
  }
`;
export const processChatRequest = /* GraphQL */ `
  mutation ProcessChatRequest($input: HccChatRequestInput!) {
    processChatRequest(input: $input) {
      sessionState {
        dialogAction {
          type
          __typename
        }
        sessionId
        intent {
          state
          __typename
        }
        __typename
      }
      messages {
        contentType
        content
        attributions
        __typename
      }
      __typename
    }
  }
`;
export const generateS3PresignedUrl = /* GraphQL */ `
  mutation GenerateS3PresignedUrl($input: S3PresignedUrlInput!) {
    generateS3PresignedUrl(input: $input) {
      presignedUrl
      videoId
      bucketName
      objectKey
      taggingStr
      __typename
    }
  }
`;
